var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import React, { createElement } from 'react';
import { forEach, assign, isEqual } from 'lodash';
import classNames from 'classnames';
import { EntitiesManager } from '../entity';
import { getStore } from '../../store';
import * as actions from '../../actions';
import { ComponentsManager } from './manager';

var DynamicComponent = function (_super) {
  __extends(DynamicComponent, _super); // 组件被创建时如果关联了实体，则创建实体的实例


  function DynamicComponent(props) {
    var _this = _super.call(this, props) || this;

    _this.setWrappedInstance = _this.setWrappedInstance.bind(_this);
    _this.getWrappedInstance = _this.getWrappedInstance.bind(_this);
    return _this;
  } // 组件加载时，初始化关联实体


  DynamicComponent.prototype.componentWillMount = function () {
    var _this = this;

    var params = this.props.params;
    var dispatch = getStore().dispatch;

    if (this.metadata.entity) {
      var entity = new (EntitiesManager.get(this.metadata.entity))(params);
      this.entity = entity;

      if (this.metadata.loaderType === 'get') {
        dispatch(actions.getAction(entity, params));
      }

      if (this.metadata.loaderType === 'search') {
        dispatch(actions.searchAction(entity, params));
      }
    }

    if (this.metadata.entities) {
      this.entities = {};
      forEach(this.metadata.entities, function (defination) {
        var name = defination.name,
            entityName = defination.entityName,
            loaderType = defination.loaderType;
        var entity = new (EntitiesManager.get(entityName))(params);
        _this.entities[name] = entity;

        if (loaderType === 'get') {
          dispatch(actions.getAction(entity, params));
        }

        if (loaderType === 'search') {
          dispatch(actions.searchAction(entity, params));
        }
      });
    }
  }; // 组件被销毁时，同时销毁已创建的实体实例


  DynamicComponent.prototype.componentWillUnmount = function () {
    var _a = this,
        entity = _a.entity,
        entities = _a.entities,
        componentId = _a.componentId;

    if (entity) {
      entity.unmount();
    }

    if (entities) {
      forEach(entities, function (entity) {
        entity.unmount();
      });
    }

    if (getStore().getState().components[componentId]) {
      getStore().dispatch(actions.unmountComponentAction(componentId));
    }
  };

  DynamicComponent.prototype.getWrappedInstance = function () {
    return this.wrappedInstance;
  };

  DynamicComponent.prototype.setWrappedInstance = function (ref) {
    this.wrappedInstance = ref;
  };

  DynamicComponent.prototype.render = function () {
    var childProps = __assign(__assign(__assign(__assign({}, this.props), this.basisProps), this.getMergeProps()), {
      componentId: this.componentId
    });

    if (childProps.withRef) {
      childProps.ref = this.setWrappedInstance;
    }

    if (this.entity) {
      childProps.entity = this.entity;
    }

    if (this.entities) {
      childProps.entities = this.entities;
    }

    return createElement(ComponentsManager.get(this.metadata.component), childProps);
  };
  /**
   * 全局组件配置 className 和 style 是可以合并的。
   * 该方法会将当前组件的 props 及 basisProps 中的待合并属性进行组合，
   * 在合并时若出现重复内容，则以当前组件配置为准。
   */


  DynamicComponent.prototype.getMergeProps = function () {
    var style = assign({}, this.basisProps.style, this.props.style);

    if (!isEqual(style, this.cachedStyle)) {
      this.cachedStyle = style;
    }

    return {
      className: classNames(this.basisProps.className, this.props.className),
      style: this.cachedStyle
    };
  };

  return DynamicComponent;
}(React.Component);

export { DynamicComponent };